import {FC} from 'react';

import {useInitialEffect} from '../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {useAppDispatch} from '../../helpers/reduxHelpers';
import {replacePathAction} from '../../store/panels/app/appPanelRouteActions';
import {NewPanelId} from '../../store/panels/panelStateBase';

/*
 * Props.
 */

interface RedirectProps {
  panelId: NewPanelId;
  to: string;
}

/*
 * Component.
 */

/** @deprecated Use Redux-based routing instead. */
export const Redirect: FC<RedirectProps> = (props) => {
  const dispatch = useAppDispatch();

  useInitialEffect(() => {
    const {panelId, to} = props;
    dispatch(replacePathAction(panelId, to));
  });

  return null;
};
